import PropTypes from 'prop-types';
import { createContext, useMemo, useState } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import palette from './palette';
import typography from './typography';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export default function ThemeProvider({ children }) {
  // const themeOptions = useMemo(
  //   () => ({
  //     palette: {
  //       mode,
  //       ...(mode === 'light' ? pallete : {}),
  //     },
  //     shape: { borderRadius: 8 },
  //     typography,
  //     shadows,
  //     customShadows,
  //   }),
  //   []
  // );

  // const theme = createTheme(themeOptions);
  const [mode, setMode] = useState('light');
  const colorMode = useMemo(
    () => ({
      setColorMode: (mode) => {
        setMode(mode);
      },
    }),
    []
  );

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === 'dark' ? {} : palette),
        },
        shape: { borderRadius: 8 },
        typography,
        shadows,
        customShadows,
      }),
    [mode]
  );
  theme.components = componentsOverride(theme);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <StyledEngineProvider injectFirst>
        <MUIThemeProvider theme={theme}>
          <CssBaseline />
          {children}
        </MUIThemeProvider>
      </StyledEngineProvider>
    </ColorModeContext.Provider>
  );
}
